export default __webpack_public_path__ + "static/media/d_events.c5637d10.png";